<template>
  <div class="techerDivDisplay">
    <title-widge
      :title="title"
      :desc="desc"
      :bgFont="bgFont"
    ></title-widge>
    <div v-if="imgUrls.length > 0">
      <common-techer-display-widge :imgs="imgUrls" class="teacher_desc">
      </common-techer-display-widge>
    </div>
  </div>
</template>

<script>
import titleWidge from "./titleWidge";
import commonTecherDisplayWidge from "../../common/components/techerDisplayWidge";
export default {
  components: {
    titleWidge,
    commonTecherDisplayWidge,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    desc: {
      type: String,
      default: "",
    },
    bgFont: {
      type: String,
      default: "",
    },
    imgUrls: {
      type: Array,
      default: function() {
        return [];
      },
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
@import "./../../web/asserts/scss/techerDisplayWidge.scss";
</style>
